<!-- 保养记录 -->
<template>
  <v-container fluid>
    <!-- 查询条件：车牌号、保养类型、保养开始日期 -->
    <v-row class="query-row">
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" label="车牌号" dense outlined clearable hide-details
          @keyup.enter="search()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-select v-model="queryForm.type" :items="types" label="保养类型" no-data-text="无" dense outlined clearable
          hide-details :menu-props="{ bottom: true, offsetY: true }">
        </v-select>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="保养开始日期" append-icon="mdi-calendar" readonly
              v-bind="attrs" v-on="on" dense outlined clearable hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="保养结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined clearable hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6">
        <a-space>
          <v-btn @click="getdata()" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-btn @click="showadd()" color="success" dark tile>
            <v-icon small>mdi-plus</v-icon>保养登记
          </v-btn>
        </a-space>
      </v-col>
    </v-row>

    <v-card tile>
      <v-card-title class="d-flex align-center py-2 px-3" style="background-color: #fff;">
        <span class="text-subtitle-2">共 {{ list.length }} 条数据</span>
        <span v-if="selectedRowKeys.length" class="text-caption grey--text ml-3">已选 {{ selectedRowKeys.length }}
          条</span>
        <v-spacer></v-spacer>
        <a-space class="mr-2">
          <!-- 批量审核：默认展示但禁用，勾选记录后变为蓝色可选 -->
          <v-btn small tile :color="selectedRowKeys.length ? 'primary' : 'grey'" :disabled="!selectedRowKeys.length"
            @click="batchreview">
            <v-icon small left>mdi-check-decagram</v-icon>批量审核
          </v-btn>
          <v-btn v-if="selectedRowKeys.length" small text tile @click="clearSelection">清空选择</v-btn>
        </a-space>
      </v-card-title>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false" bordered
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width }" :row-selection="rowSelection">
        <!-- 序号：合计行显示"合计"，其余按当前页累加 -->
        <template slot="index" slot-scope="text, record, index">
          <span v-if="record._isSummary" class="font-weight-bold primary--text">合计</span>
          <span v-else>{{ index + 1 }}</span>
        </template>
        <template slot="type" slot-scope="text, record">
          <template v-for="type in types">
            <v-chip v-if="record.type === type.value" :key="type.value" label outlined small
              :color="$utils.textToBgColor(type.text)">{{ type.text }}</v-chip>
          </template>
        </template>
        <!-- 金额列保留两位小数；合计行加粗 -->
        <template slot="parts_cost" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ formatMoney(text) }}</span>
        </template>
        <template slot="labor_cost" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ formatMoney(text) }}</span>
        </template>
        <template slot="total_cost" slot-scope="text">
          <span class="font-weight-bold primary--text">{{ formatMoney(text) }}</span>
        </template>
        <!-- 审核状态：0 待审核 / 1 已通过 / 2 已驳回 -->
        <template slot="review_state" slot-scope="text, record">
          <template v-if="!record._isSummary">
            <a-tag v-if="record.review_state === 1" color="green">已通过</a-tag>
            <a-tag v-else-if="record.review_state === 2" color="red">已驳回</a-tag>
            <a-tag v-else color="orange">待审核</a-tag>
          </template>
        </template>
        <!-- 操作：合计行/已通过审核的记录不显示编辑、删除；驳回的可修改后重新提交 -->
        <template slot="action" slot-scope="text, record">
          <template v-if="record._isSummary || record.review_state === 1">
            <span class="grey--text">--</span>
          </template>
          <a-space v-else>
            <a @click="showedit(record._id)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确认删除该保养记录?" ok-text="确定" cancel-text="取消" placement="left"
              @confirm="remove(record._id)">
              <a class="error--text">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <!-- 保养登记 / 编辑弹窗 -->
    <v-dialog v-model="formmodel" max-width="860" persistent scrollable>
      <v-form ref="form" v-model="formvalid" :lazy-validation="true">
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ formtitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="4">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select v-model="form.own_type" :items="own_types" item-text="label" item-value="value" label="车辆来源"
                    dense outlined :menu-props="{ bottom: true, offsetY: true }"></v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="form.driver_name" label="司机姓名" dense outlined></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select v-model="form.type" :items="types" :rules="[vrules.required]" dense outlined
                    :menu-props="{ bottom: true, offsetY: true }">
                    <template v-slot:label>
                      保养类型 <span class="red--text">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model.number="form.km" :rules="[vrules.required]" type="number" dense outlined>
                    <template v-slot:label>
                      送保公里数(KM) <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model.number="form.interval_km" label="下次保养间隔(KM)" type="number" dense outlined
                    hint="填写后自动计算下次保养公里数，可手动修改" persistent-hint></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model.number="form.parts_cost" label="配件费(元)" type="number" dense outlined>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model.number="form.labor_cost" label="工时费(元)" type="number" dense outlined>
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <!-- 保养费用 = 配件费 + 工时费，自动计算只读 -->
                  <v-text-field :value="formTotalFee" label="保养费用(元)" dense outlined readonly></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-menu ref="form_start_menu" v-model="form_start_menu" :close-on-content-click="false"
                    :return-value.sync="form.start_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.start_day" label="保养开始日期" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="form.start_day" no-title scrollable locale="zh-cn"
                      @input="() => { $refs.form_start_menu.save(form.start_day); form_start_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4">
                  <v-menu ref="form_end_menu" v-model="form_end_menu" :close-on-content-click="false"
                    :return-value.sync="form.end_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.end_day" label="保养结束日期" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="form.end_day" no-title scrollable locale="zh-cn"
                      @input="() => { $refs.form_end_menu.save(form.end_day); form_end_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4">
                  <v-text-field :value="nextKm" label="下次保养公里数(KM)" dense outlined readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.items" label="保养项目" dense outlined rows="2"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text tile @click="cancelsave">取消</v-btn>
            <v-btn color="primary" dark tile :disabled="!formvalid" @click="save">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- 批量审核弹窗：通过审核 / 驳回 + 备注 -->
    <v-dialog v-model="reviewmodel" max-width="520" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          批量审核（{{ reviewform.ids.length }} 条）
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="reviewform" v-model="reviewvalid" :lazy-validation="true">
            <!-- 审核结果：1 通过 / 2 驳回 -->
            <v-radio-group v-model="reviewform.state" row :rules="[vrules.required]">
              <v-radio color="success" label="通过审核" :value="1"></v-radio>
              <v-radio color="error" label="驳回" :value="2"></v-radio>
            </v-radio-group>
            <!-- 驳回时备注必填 -->
            <v-textarea v-model="reviewform.remark" label="审核备注" dense outlined rows="3"
              :rules="reviewform.state === 2 ? [vrules.required] : []"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text tile @click="reviewmodel = false">取消</v-btn>
          <!-- 通过/驳回按钮颜色随结果变化 -->
          <v-btn color="primary" dark tile @click="review">
            {{ reviewform.state === 2 ? "确认驳回" : "通过审核" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";

export default {
  name: "Maintenance",
  data() {
    return {
      queryForm: {
        vehicle_number: "",
        type: null,
        start_day: "",
        end_day: "",
      },
      start_day_menu: false,
      end_day_menu: false,
      types: [],
      own_types: [],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 70, align: "center" },
        { title: "送保公里数", dataIndex: "km", width: 110, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", width: 110, align: "center" },
        { title: "司机姓名", dataIndex: "driver_name", width: 100, align: "center" },
        { title: "车辆来源", dataIndex: "own_type_name", width: 100, align: "center" },
        { title: "保养类型", dataIndex: "type", scopedSlots: { customRender: "type" }, width: 100, align: "center" },
        { title: "下次保养间隔(KM)", dataIndex: "interval_km", width: 140, align: "center" },
        { title: "保养项目", dataIndex: "items", width: 200, align: "left" },
        { title: "配件费(元)", dataIndex: "parts_cost", scopedSlots: { customRender: "parts_cost" }, width: 100, align: "center" },
        { title: "工时费(元)", dataIndex: "labor_cost", scopedSlots: { customRender: "labor_cost" }, width: 100, align: "center" },
        { title: "保养费用(元)", dataIndex: "total_cost", scopedSlots: { customRender: "total_cost" }, width: 110, align: "center" },
        { title: "保养开始日期", dataIndex: "start_day", width: 120, align: "center" },
        { title: "保养结束日期", dataIndex: "end_day", width: 120, align: "center" },
        { title: "下次保养公里数", dataIndex: "next_km", width: 130, align: "center" },
        { title: "状态", dataIndex: "review_state", scopedSlots: { customRender: "review_state" }, width: 90, align: "center" },
        { title: "审核备注", dataIndex: "review_remark", width: 180, align: "left", ellipsis: true },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 120, align: "center", fixed: "right" },
      ],
      list: [],
      selectedRowKeys: [],
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      formtitle: "",
      formmodel: false,
      formvalid: true,
      form: {},
      form_start_menu: false,
      form_end_menu: false,
      reviewmodel: false,
      reviewvalid: false,
      reviewform: {
        ids: [],
        state: 1, // 1 通过 / 2 驳回
        remark: "",
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 120), 0);
    },
    formTotalFee() {
      const parts = Number(this.form.parts_cost) || 0;
      const labor = Number(this.form.labor_cost) || 0;
      return (parts + labor).toFixed(2);
    },
    nextKm() {
      const km = Number(this.form.km) || 0;
      const interval_km = Number(this.form.interval_km) || 0;
      return km + interval_km;
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (keys, rows) => {
          this.selectedRowKeys = keys;
        },
        getCheckboxProps: (record) => ({
          props: { disabled: record._isSummary || record.review_state !== 0 },
        }),
      };
    },
  },
  mounted() {
    this.getdata();
  },
  methods: {
    formatMoney(v) {
      return v == null || v === "" ? "0.00" : Number(v).toFixed(2);
    },
    clearSelection() {
      this.selectedRowKeys = [];
    },
    getdata() {
      this.selectedRowKeys = [];
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclemaintenance/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = [
            ...(() => {
              if (res.data.list.length > 1) {
                const sum = (key) => res.data.list.reduce((a, b) => a.plus(b[key] || 0), this.$d()).toString();
                return [
                  {
                    _id: "summary",
                    _isSummary: true,
                    number: "合计",
                    parts_cost: sum("parts_cost"),
                    labor_cost: sum("labor_cost"),
                    total_cost: sum("total_cost"),
                  }
                ];
              }
              return [];
            })(),
            ...res.data.list,
          ];
          this.types = res.data.types;
          this.own_types = res.data.own_types;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    info(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/vehiclemaintenance/info", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.form = res.data.dataForm;
          this.formmodel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.info().then(() => {
        this.formtitle = "保养登记";
      });
    },
    showedit(_id) {
      this.info(_id).then(() => {
        this.formtitle = "修改保养登记";
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclemaintenance/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success("已保存");
          this.formmodel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.formmodel = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclemaintenance/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success("已删除");
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    batchreview() {
      this.reviewform = {
        ids: this.selectedRowKeys,
        state: 1,
        remark: ""
      };
      this.reviewmodel = true;
    },
    review() {
      if (!this.$refs.reviewform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclemaintenance/review", { dataForm: this.reviewform }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success("已审核");
          this.reviewmodel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/* 查询条件行与下方表格保持间距（需高于上面的 .row !important） */
/deep/ .row.query-row {
  margin-bottom: 16px !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

p {
  margin: 0;
}
</style>
